import Const from 'const';
import {LateSwapCsvDataInterface} from 'components/organisms/late-swap/late-swap-interfaces';

class LateSwapCsvData implements LateSwapCsvDataInterface {
    constructor(public readonly data: any[] = []) {}
    getAllAsArr(): any[] {
        return [...this.data];
    }
}

const lateSwapCsvData = new LateSwapCsvData();

export default function (state = lateSwapCsvData, action) {
    switch (action.type) {
        case Const.LATESWAP_SET_UPLOADED_CSV_DATA:
            return new LateSwapCsvData(action.csvData);

        case Const.FILTER_BY_SLATE:
            return new LateSwapCsvData();

        default:
            return state;
    }
}
